import {
  SidePanelSheetMode,
  useReservationServiceContext,
} from '../state/ReservationServiceContext';
import { Kebab } from '@components/kebab/Kebab';

export const SplitMergeKebabMenu = () => {
  const { setSidePanelSheet } = useReservationServiceContext();

  return (
    <Kebab
      options={[
        {
          label: 'Split/Merge',
          onClick: () =>
            setSidePanelSheet({ mode: SidePanelSheetMode.SplitMerge }),
        },
      ]}
      side="bottom"
      ariaLabelPrefix="floor"
    />
  );
};
